import React, { useEffect, useContext, useState, useActionState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Context_UI } from '../../Contexts/Context_UI';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';

import UI_Card from '../ERUMAUI/UI_Card';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_UpdatingStatus from '../ERUMAUI/UI_UpdatingStatus';
import Icon_Calendar_NoUpcoming from '../../Assets/Icons/Icon_Color_Reserved.png';

export default function List_Activities() {
    const { Time_Range_Parse, Schedules, Schedule_Display } = useScheduleManagement();
    const { Room_Get_Address } = useMapRenderer();
    const Navigate = useNavigate();

    // 1. Initial State
    const [Schedules_Now, Schedules_Now_Set] = useState([]);
    const [Schedules_Later, Schedules_Later_Set] = useState([]);
    const [Schedules_ThisWeek, Schedules_ThisWeek_Set] = useState([]);
    const [Schedules_ThisMonth, Schedules_ThisMonth_Set] = useState([]);
    const [Activities_Enabled, Activities_Enabled_Set] = useState(true);

    // Helper to clear everything
    const resetLists = () => {
        Schedules_Now_Set([]);
        Schedules_Later_Set([]);
        Schedules_ThisWeek_Set([]);
        Schedules_ThisMonth_Set([]);
        Activities_Enabled_Set(false);
    };

    useEffect(() => {
        const FreshNow = new Date();

        if (!Schedules || Schedules.length === 0) {
            resetLists();
            return;
        }

        // Filter for Approved first
        const Approved = Schedules.filter(s => s.Approval?.Final?.State === "Approved");
        if (Approved.length === 0) {
            resetLists();
            return;
        }

        // Date Boundary Logic
        const Today_End = new Date(FreshNow);
        Today_End.setHours(23, 59, 59, 999);

        const Week_End = new Date(FreshNow);
        Week_End.setDate(FreshNow.getDate() + (6 - FreshNow.getDay()));
        Week_End.setHours(23, 59, 59, 999);

        const Month_End = new Date(FreshNow.getFullYear(), FreshNow.getMonth() + 1, 0, 23, 59, 59, 999);

        const List_Now = [];
        const List_Later = [];
        const List_Week = [];
        const List_Month = [];

        Approved.forEach((Schedule) => {
            const Start = new Date(Schedule.Time.Start);
            const End = new Date(Schedule.Time.End);

            if (FreshNow >= Start && FreshNow <= End) List_Now.push(Schedule);
            else if (Start > FreshNow && End <= Today_End) List_Later.push(Schedule);
            else if (Start > Today_End && End <= Week_End) List_Week.push(Schedule);
            else if (Start > Week_End && End <= Month_End) List_Month.push(Schedule);
        });

        // Update State
        const hasData = List_Now.length > 0 || List_Later.length > 0 || List_Week.length > 0 || List_Month.length > 0;

        Schedules_Now_Set(Group_ByRoom(List_Now));
        Schedules_Later_Set(Group_ByRoom(List_Later));
        Schedules_ThisWeek_Set(Group_ByRoom(List_Week));
        Schedules_ThisMonth_Set(Group_ByRoom(List_Month));
        Activities_Enabled_Set(hasData);

    }, [Schedules]);

    // Grouping Helper
    const Group_ByRoom = (Input) => {
        if (!Input.length) return [];
        const Groups = Input.reduce((acc, schedule) => {
            const id = schedule.RoomID;
            if (!acc[id]) acc[id] = [];
            acc[id].push(schedule);
            return acc;
        }, {});

        return Object.entries(Groups).map(([RoomID, List]) => ({ RoomID, List }));
    };

    const Handle_Click = (ID) => {
        Schedule_Display(ID);
        Navigate("/schedules");
    };

    return (
        <UI_UpdatingStatus
            State={Activities_Enabled ? "Good" : "Bad"}
            Good={{
                Type: "Custom",
                Content: (
                    <>
                        <ActivitySection title="Happening now" data={Schedules_Now} />
                        <ActivitySection title="Happening later today" data={Schedules_Later} />
                        <ActivitySection title="Upcoming activities this week" data={Schedules_ThisWeek} />
                        <ActivitySection title="Upcoming activities this month" data={Schedules_ThisMonth} />
                    </>
                )
            }}
            Bad={{
                Type: "Default",
                Icon: Icon_Calendar_NoUpcoming,
                Text: "No fully approved activities for now."
            }}
        />
    );

    // Sub-component for cleaner JSX
    function ActivitySection({ title, data }) {
        if (!data.length) return null;
        return (
            <div className='SM_Activities'>
                <div className='SM_Activities_Title'>
                    <h3 className='General_Paragraph'>{title}</h3>
                </div>
                <div className='General_Grid SM_Activities_List'>
                    {data.map((Room) => (
                        <div key={Room.RoomID} className='SM_Activities_List_Group'>
                            <UI_Divider Text={Room_Get_Address(Room.RoomID)} />
                            <div className='SM_Activities_List_Content'>
                                {Room.List.map((Schedule) => (
                                    <UI_Card
                                        key={Schedule._id}
                                        Type="Schedule_List"
                                        Figure={{
                                            Title: Schedule.Name,
                                            Main: Time_Range_Parse(Schedule.Time.Start, Schedule.Time.End)
                                        }}
                                        onClick={() => Handle_Click(Schedule._id)}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}